// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__7Lu4a","head":"Table_head__3tLWL","col":"Table_col__3FPds"};